import { create } from "zustand";
import { persist } from "zustand/middleware";
import dayjs, { Dayjs } from "dayjs";

export type MonthRange = [Dayjs, Dayjs] | null;

type DateRangeState = {
  monthRange: MonthRange;
  setMonthRange: (range: MonthRange) => void;
  resetMonthRange: () => void;

  fromMonth: string | null;
  toMonth: string | null;
};

const formatMonth = (d: Dayjs | null) => (d ? d.format("YYYY-MM") : null);

// ✅ DEFAULT: 2026-01 .. 2027-12
const DEFAULT_RANGE: [Dayjs, Dayjs] = [
  dayjs("2025-03", "YYYY-MM"),
  dayjs("2026-02", "YYYY-MM"),
];

export const useDateRangeStore = create<DateRangeState>()(
  persist(
    (set) => ({
      // ✅ initial
      monthRange: DEFAULT_RANGE,
      fromMonth: formatMonth(DEFAULT_RANGE[0]),
      toMonth: formatMonth(DEFAULT_RANGE[1]),

      setMonthRange: (range) => {
        set({
          monthRange: range,
          fromMonth: range ? formatMonth(range[0]) : null,
          toMonth: range ? formatMonth(range[1]) : null,
        });
      },

      resetMonthRange: () => {
        set({
          monthRange: DEFAULT_RANGE,
          fromMonth: formatMonth(DEFAULT_RANGE[0]),
          toMonth: formatMonth(DEFAULT_RANGE[1]),
        });
      },
    }),
    {
      name: "app-month-range",
      partialize: (s) => ({
        fromMonth: s.fromMonth,
        toMonth: s.toMonth,
      }),
      onRehydrateStorage: () => (state) => {
        if (!state) return;

        const { fromMonth, toMonth } = state;

        // ✅ persisted bo'lsa shuni tiklaymiz
        if (fromMonth && toMonth) {
          state.monthRange = [
            dayjs(fromMonth, "YYYY-MM"),
            dayjs(toMonth, "YYYY-MM"),
          ];
          return;
        }

        // ✅ persisted yo'q bo'lsa default 2026-2027
        state.monthRange = DEFAULT_RANGE;
        state.fromMonth = formatMonth(DEFAULT_RANGE[0]);
        state.toMonth = formatMonth(DEFAULT_RANGE[1]);
      },
    },
  ),
);
